import {
  compareYearMonth,
  firstDayOf,
  formatDay,
  IYearMonth,
  toYearMonth,
} from '~/utils/date/date';

const getDefaultEffectiveDate = (today: Date, selected: IYearMonth): string =>
  formatDay(compareYearMonth(selected, toYearMonth(today)) === 0 ? today : firstDayOf(selected));

export default getDefaultEffectiveDate;
